import React, { useEffect, useState } from "react";
import ConfirmationModal from "@enerex/unified-ui-react/ConfirmationModal";
import Select from "components/UnifiedSelect";
import FormInput from "components/FormInput/index";
import FormInput2 from "components/FormInput2";
import { getEnerexIdentifier, normalizeGuidValue, toOption, utilitySelectStyles, getUtilityId } from "../utilityUtils";
const UtilityFormModal = ({ show, onHide, onSave, utility, utilityOptions, saving }) => {
  const [form, setForm] = useState({
    Id: 0,
    EnerexIdentifier: "",
    EnerexUtilityId: "",
    Name: "",
    LongName: "",
    ParentEXID: "",
    ParentEnerexId: "",
    ParentUtilityId: 0,
    MergedWithEXID: "",
    EnerexMergedWithId: "",
    MergedWithUtilityId: 0,
    WebSite: "",
    Website: "",
    Duns: "",
    DunsNumber: "",
    PurchaseOfReceivables: false,
  });
  const [parentUtilityOption, setParentUtilityOption] = useState(null);
  const [mergedUtilityOption, setMergedUtilityOption] = useState(null);

  useEffect(() => {
    if (!show) {
      setParentUtilityOption(null);
      setMergedUtilityOption(null);
      return;
    }
    const rawParentEXID = utility?.parentEXID || utility?.ParentEXID || utility?.parentEnerexId || utility?.ParentEnerexId || "";
    const rawMergedWithEXID = utility?.mergedWithEXID || utility?.MergedWithEXID || utility?.enerexMergedWithId || utility?.EnerexMergedWithId || "";
    setForm({
      Id: utility?.id || utility?.Id || 0,
      EnerexIdentifier: getEnerexIdentifier(utility),
      EnerexUtilityId: getEnerexIdentifier(utility),
      Name: utility?.name || utility?.Name || "",
      LongName: utility?.longName || utility?.LongName || "",
      ParentEXID: normalizeGuidValue(rawParentEXID),
      ParentEnerexId: normalizeGuidValue(rawParentEXID),
      ParentUtilityId: utility?.parentUtilityId || utility?.ParentUtilityId || 0,
      MergedWithEXID: normalizeGuidValue(rawMergedWithEXID),
      EnerexMergedWithId: normalizeGuidValue(rawMergedWithEXID),
      MergedWithUtilityId: utility?.mergedWithUtilityId || utility?.MergedWithUtilityId || 0,
      WebSite: utility?.webSite || utility?.WebSite || "",
      Website: utility?.webSite || utility?.WebSite || "",
      Duns: utility?.duns || utility?.Duns || "",
      DunsNumber: utility?.duns || utility?.Duns || "",
      PurchaseOfReceivables:
        utility?.PurchaseOfReceivables ?? utility?.purchaseOfReceivables ?? false,
    });

    const resolvedParent = utilityOptions
      .map((u) => toOption(u))
      .find((o) => String(o.value) === normalizeGuidValue(rawParentEXID) || String(getUtilityId(o.raw)) === String(utility?.parentUtilityId || utility?.ParentUtilityId || 0)) || null;
    const resolvedMerged = utilityOptions
      .map((u) => toOption(u))
      .find((o) => String(o.value) === normalizeGuidValue(rawMergedWithEXID) || String(getUtilityId(o.raw)) === String(utility?.mergedWithUtilityId || utility?.MergedWithUtilityId || 0)) || null;

    setParentUtilityOption(resolvedParent);
    setMergedUtilityOption(resolvedMerged);

  }, [show, utility, utilityOptions]);

  const options = utilityOptions
    .map((u) => toOption(u))
    .filter((o) => o.value && o.value !== form.EnerexIdentifier);

  const parentValue =
    parentUtilityOption ||
    options.find((o) => String(o.value) === String(form.ParentEnerexId)) ||
    null;
  const mergedValue =
    mergedUtilityOption ||
    options.find((o) => String(o.value) === String(form.EnerexMergedWithId)) ||
    null;

  return (
    <ConfirmationModal
      dialogClassName="modal-md"
      centered
      show={show}
      onHide={onHide}
      title={form.Id ? "Edit Utility" : "Add Utility"}
      confirmButtonLabel={saving ? "Saving..." : "Save"}
      confirmButtonVariant="primary"
      isLoading={saving}
      onConfirm={() => {
        if (!form.Name.trim()) return;
        onSave(form);
      }}
    >
        <FormInput
          type="text"
          label={<>Name <span className="text-danger">*</span></>}
          containerClass="mb-3"
          value={form.Name}
          onChange={(e) => setForm((f) => ({ ...f, Name: e.target.value }))}
          placeholder="Enter name"
        />
        <FormInput
          type="text"
          label="Long Name"
          containerClass="mb-3"
          value={form.LongName}
          onChange={(e) => setForm((f) => ({ ...f, LongName: e.target.value }))}
          placeholder="Enter long name"
        />
        <div className="mb-3">
          <label className="form-label">Parent Utility</label>
          <Select
            options={options}
            value={parentValue}
            onChange={(value) => {
              const parentEnerexId = normalizeGuidValue(
                value?.raw?.enerexUtilityId ||
                value?.raw?.EnerexUtilityId ||
                value?.raw?.enerexIdentifier ||
                value?.raw?.EnerexIdentifier
              );
              const parentUtilityId = getUtilityId(value?.raw);
              setParentUtilityOption(value || null);
              setForm((f) => ({
                ...f,
                ParentEXID: parentEnerexId,
                ParentEnerexId: parentEnerexId,
                ParentUtilityId: parentUtilityId,
              }));
            }}
            isClearable
            placeholder="Select utility"
            styles={utilitySelectStyles}
            menuPortalTarget={document.body}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Merged With Utility</label>
          <Select
            options={options}
            value={mergedValue}
            onChange={(value) => {
              const mergedEnerexId = normalizeGuidValue(
                value?.raw?.enerexUtilityId ||
                value?.raw?.EnerexUtilityId ||
                value?.raw?.enerexIdentifier ||
                value?.raw?.EnerexIdentifier
              );
              const mergedUtilityId = getUtilityId(value?.raw);
              setMergedUtilityOption(value || null);
              setForm((f) => ({
                ...f,
                MergedWithEXID: mergedEnerexId,
                EnerexMergedWithId: mergedEnerexId,
                MergedWithUtilityId: mergedUtilityId,
              }));
            }}
            isClearable
            placeholder="Select utility"
            styles={utilitySelectStyles}
            menuPortalTarget={document.body}
          />
        </div>
        <FormInput
          type="text"
          label="Website"
          containerClass="mb-3"
          value={form.WebSite}
          onChange={(e) =>
            setForm((f) => ({ ...f, WebSite: e.target.value, Website: e.target.value }))
          }
          placeholder="Enter URL"
        />
        <FormInput
          type="text"
          label="DUNS Number"
          value={form.Duns}
          onChange={(e) =>
            setForm((f) => ({ ...f, Duns: e.target.value, DunsNumber: e.target.value }))
          }
          placeholder="Enter DUNS number"
        />
        <FormInput2
            type="checkbox"
            name="PurchaseOfReceivables"
            id="purchase-of-receivables"
            containerClass="mt-3"
            label="POR"
            checked={Boolean(form.PurchaseOfReceivables)}
            onChange={(e) =>
              setForm((f) => ({ ...f, PurchaseOfReceivables: e.target.checked }))
            }
          />
    </ConfirmationModal>
  );
};
export default UtilityFormModal;
